import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GET_COLLEGE_CERTIFICATES, DELETE_COLLEGE_CERTIFICATE } from "api";
import EnhancedTable from "@vocollege/components/dist/EnhancedTable";
import Layout from "containers/Layout/Layout";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { useStyles as useStylesContentList } from "ui/styles/contentList";
import DownloadButton from "components/DownloadButton";
import CollegeCertificateTemplate from "containers/Templates/CollegeCertificate";
import { getFileName } from "services/Utils";
import GroupTitle from "components/GroupTitle";

const CollegeCertificates: React.FC = (props) => {
  let navigate = useNavigate();
  const classesContentList = useStylesContentList();

  const editItem = (id = "skapa") => {
    navigate(`/college-certifikat/${id}`);
  };

  const getActionButtons = () => {
    let buttons = [];
    if (VoAuth.ability.can("update_own_college_certificates", "Cert")) {
      buttons.push("edit");
    }
    if (VoAuth.ability.can("delete_own_college_certificates", "Cert")) {
      buttons.push("delete");
    }
    return buttons;
  };

  const getCustomActionButtons = (row: any) => {
    return (
      <>
        <DownloadButton
          auditResource={{ resourceType: "CollegeCertificate", id: String(row.id) }}
          className={classesContentList.actionButton}
          document={<CollegeCertificateTemplate item={row} />}
          fileName={`${getFileName([
            row && row.firstname,
            row && row.lastname,
          ])}.pdf`}
        />
      </>
    );
  };

  return (
    <Layout>
      <EnhancedTable
        className="vo-global__top-bottom-space"
        title={I18n.get.collegeCertificate.labels.collegeCertificates}
        operations={{
          category: "certCollegeCertificates",
          get: GET_COLLEGE_CERTIFICATES,
          delete: DELETE_COLLEGE_CERTIFICATE,
        }}
        labels={{
          deleted: I18n.get.collegeCertificate.messages.certificateDeleted,
        }}
        columns={[
          { title: "ID", field: "id", width: 90 },
          {
            title: I18n.get.misc.college,
            field: "college",
            width: 200,
            render: (data) => <GroupTitle item={data?.college} />,
          },
          {
            title: I18n.get.collegeCertificate.labels.from,
            field: "from",
            width: 200,
          },
          {
            title: I18n.get.collegeCertificate.labels.to,
            field: "to",
            width: 200,
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
        ]}
        addItem={
          VoAuth.ability.can("create_own_certificates", "Cert")
            ? editItem
            : undefined
        }
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        actionButtons={getActionButtons()}
        renderActionButtons={getCustomActionButtons}
      />
    </Layout>
  );
};

export default CollegeCertificates;
